import { Injectable } from '@angular/core';
import { ProjectReportApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { ProjectReportAction } from '../actions';

@Injectable()
export class ProjectReportEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(ProjectReportAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => ProjectReportAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: ProjectReportApiService, private _actions$: Actions, private _store: Store) {}
}
